<template>
  <modal
    name="widgets"
    :click-to-close="false"
    :adaptive="true"
    :scrollable="true"
    width="75%"
    :max-width="700"
    height="auto"
    :pivot-y="pivotY"
    @before-open="onBeforeOpen"
  >
    <Button
      class="close-button"
      :disabled="addingWidget"
      :title="closeButtonTitle"
      @click="$modal.hide('widgets')"
    >
      <v-icon slot="icon-end" name="times" />
    </Button>
    <h1 class="widget-modal-title">
      Add New Section
    </h1>
    <Widgets
      :campaign-id="campaignId"
      @update:addingWidget="addingWidget = $event"
    />
  </modal>
</template>

<script>
import Widgets from "@/components/Editor/Layout/Widgets/Widgets";

export default {
  name: "WidgetsModal",
  components: { Widgets },
  data() {
    return {
      addingWidget: false,
      campaignId: "",
      pivotY: window.innerWidth > 768 ? 0.1 : 0.3,
    };
  },
  computed: {
    closeButtonTitle() {
      return this.addingWidget ? "Please wait..." : "Close";
    },
  },
  methods: {
    onBeforeOpen(event) {
      this.campaignId = event.params.campaignId;
    },
  },
};
</script>

<style scoped>
>>> .v--modal {
  @apply p-4 overflow-auto;
  max-height: 600px;

  @screen md {
    @apply px-6;
    max-height: 800px;
  }

  @screen lg {
    max-height: 1000px;
  }
}

.widget-modal-title {
  @apply text-support text-base my-2 text-center;

  @screen md {
    @apply text-xl mb-0;
  }
}
</style>
